<template>
	<FABDialog
		ref="archive"
		color="secondary"
		tooltip="View Archived Projects"
		icon="unarchive"
	>
		<template slot="dialog">
			<v-container>
				<v-layout row>
					<v-flex class="text-xs-center">
						<h1
							v-if="archivedProjects.length > 0"
							class="headline"
						>
							Archived Projects
						</h1>
						<h1
							v-else
							class="title"
						>
							No Archived Projects
						</h1>
					</v-flex>
				</v-layout>
				<v-layout
					row
					wrap
				>
					<v-flex
						v-for="item in archivedProjects.models"
						:key="item.id"
						xs12
						sm6
						pa-2
					>
						<v-card
							class="pa-2 archived-project-card"
						>
							<v-layout
								row
								align-center
							>
								<v-flex xs6>
									<div class="subheading pl-3">
										{{ item.name }}
										<span
											v-if="item.date"
											class="caption"
										>
											- {{ item.date }}
										</span>
									</div>
								</v-flex>
								<v-spacer/>
								<v-btn
									:to="item.url"
									flat
								>
									View
								</v-btn>
								<v-btn
									v-if="item.userCan('manage_projects')"
									flat
									color="success"
									@click="restoreProject(item)"
								>
									Restore
								</v-btn>
							</v-layout>
							<div
								v-if="item.saving"
								class="loading-overlay"
							>
								<v-progress-circular
									indeterminate
									color="primary"
								/>
							</div>
						</v-card>
					</v-flex>
				</v-layout>
			</v-container>
		</template>
	</FABDialog>
</template>

<script>
import FABDialog from '@/components/FABDialog';

export default {
	components: {
		FABDialog,
	},
	computed: {
		archivedProjects() {
			return this.$store.get('projects/archived');
		},
	},
	methods: {
		restoreProject(project) {
			project.isArchived = false;
			project.save().then(() => {
				this.$store.dispatch('projects/restore', project);
				this.$notify('success', `"${project.name}" has been restored.`);
			}).catch(() => {
				this.$notify('error', 'Failed to restort project.');
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.archived-project-card {
	position: relative;
}
.loading-overlay {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(255, 255, 255, 0.8);
	display: flex;
	justify-content: center;
	align-items: center;
}
</style>
